import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * AuthCallback — Google OAuth was disabled.
 * Any incoming session_id from a stale Google redirect is ignored;
 * the user is redirected to /connexion with a notice.
 */
const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try { sessionStorage.removeItem('dz_oauth_intent'); } catch { /* ignore */ }
    navigate('/connexion', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center text-[#5A5247]">Redirection…</div>
    </div>
  );
};

export default AuthCallback;
